import { RefreshCw, AlertCircle } from 'lucide-react';
import { Button } from './ui/button';

export const PageError = ({ message, onRetry }) => (
  <div className="rounded-2xl border border-red-100 bg-red-50/50 p-8 text-center" data-testid="page-error">
    <div className="mx-auto w-12 h-12 rounded-xl bg-red-100 flex items-center justify-center mb-4">
      <AlertCircle className="h-6 w-6 text-red-500" strokeWidth={1.5} />
    </div>
    <h3 className="text-lg font-semibold text-black">Er ging iets mis</h3>
    <p className="text-sm text-neutral-500 mt-1 max-w-sm mx-auto">
      {message || 'De gegevens konden niet worden geladen. Controleer je verbinding en probeer opnieuw.'}
    </p>
    {onRetry && (
      <Button variant="outline" onClick={onRetry} className="mt-4 border-black text-black" data-testid="page-error-retry">
        <RefreshCw className="h-4 w-4 mr-1.5" strokeWidth={1.5} />
        Opnieuw laden
      </Button>
    )}
  </div>
);
